import stylesC from '../../styles/common.module.css';
import ProductDeliveryRobot from '../../components/product/ProductDeliveryRobot';
import ProductAmrRobot from '../../components/product/ProductAmrRobot';


export default function ProductsPage() {
    return (
        <main className={stylesC.main}>
            <section >
                <ProductDeliveryRobot />
            </section>
            <section >
                <ProductAmrRobot />
            </section>
        </main>
    )
}
